var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"page-header"},[_c('h1',{staticClass:"pl-5 title text-light"},[_vm._v("Ofertas")])]),_c('main',[_c('div',{staticClass:"container"},[_c('h2',[_vm._v("No hay Ofertas disponibles en este momento")])])])])
}]

export { render, staticRenderFns }